var lists_default = {
  "fontElementMap": "_2rzCn",
  "orderedlist": "o8mjA",
  "bulletedlist": "InLn6",
  "listItem": "YPH8D"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
